import { LOADING_TABLEDATA, GET_TABLEDATA } from "../Actions/types";

const initialState = {
  tableData: [],
  loading_tableData: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case LOADING_TABLEDATA:
      return {
        ...state,
        loading_tableData: true
      };
    case GET_TABLEDATA:
      return {
        ...state,
        tableData: action.payload,
        loading_tableData: false
      };
    default:
      return state;
  }
}
